// StyledErrorText.js
import styled from "styled-components";

import React, { useContext } from "react";

import { FormBuilderContext } from "../context/context";
const StyledErrorTextBase = styled.label`
  outline: none;
  padding: 0 ${({ styling }) => `${styling.errorTextPaddingInline}px`};
  font-size: ${({ styling }) => `${styling.errorTextFontSize}px`};
  font-weight: ${({ styling }) => styling.errorTextFontWeight};
  font-family: ${({ styling }) => styling.errorTextFontFamily};
  transition: ${(props) => props.theme.transitionMain};
  margin-top: ${({ styling }) => styling.errorTextTopSpacing}px;
  color: ${({ styling }) => styling.errorTextColor};
`;

const StyledErrorText = (props) => {
  const { state } = useContext(FormBuilderContext);
  const placeholderText = state.addPlaceholders ? "Example Text" : "";

  return <StyledErrorTextBase {...props} placeholder={placeholderText} />;
};



export default StyledErrorText;
